<div [formGroup]="filterForm" class="filter-grid">
  <!-- Identifikátor šablony -->
  <ui-autocomplete
    label="Identifikátor"
    placeholder="Začněte psát text..."
    [field]="null"
    [minSearchLength]="2"
    [maxLength]="15"
    [autoHighlight]="false"
    formControlName="interniId"
    (handleAction)="handleIdentifikatorSearch($event)"
    [options]="identifikatorResults()"
    [attr.data-cy]="Cy_Katalog.identifikator" />

  <!-- Název šablony -->
  <ui-autocomplete
    label="Název"
    placeholder="Začněte psát text..."
    field="showField"
    [minSearchLength]="2"
    [maxLength]="100"
    [autoHighlight]="false"
    formControlName="nazev"
    (handleAction)="handleNazevSearch($event)"
    [options]="nazevResults()"
    [attr.data-cy]="Cy_Katalog.nazev" />

  <!-- Verze -->
  <ui-input
    [maxLength]="10"
    placeholder="Začněte psát text..."
    class="filter-grid-field"
    label="Verze"
    type="text"
    pattern="^(\d+)?$"
    formControlName="verze"
    [attr.data-cy]="Cy_Katalog.verze" />

  <!-- Typ -->
  <ui-select
    class="filter-grid-field"
    formControlName="typ"
    label="Typ"
    [options]="typOptions"
    [clearable]="true"
    [attr.data-cy]="Cy_Katalog.typ" />

  <!-- Gestor šablony -->
  <ui-autocomplete
    label="Gestor"
    placeholder="Začněte psát text..."
    field="showField"
    [minSearchLength]="2"
    [maxLength]="100"
    [autoHighlight]="false"
    formControlName="gestor"
    (handleAction)="handleGestorSearch($event)"
    [options]="gestorResults()"
    [attr.data-cy]="Cy_Katalog.gestor" />

  <!-- Datum publikování -->
  <div>
    <ui-datepicker-range
      label="Publikováno"
      formControlName="datumPublikovani"
      dataType="dateAsString"
      fromKey="dateFrom"
      toKey="dateTo"
      [attr.data-cy]="Cy_Katalog.publikovano" />
  </div>

  <!-- Platná od -->
  <div>
    <ui-datepicker-range
      label="Platnost od"
      formControlName="platnostOd"
      dataType="dateAsString"
      fromKey="dateFrom"
      toKey="dateTo"
      data-cy="katalog-platnost-od" />
  </div>

  <!-- Platná do -->
  <div>
    <ui-datepicker-range
      label="Platnost do"
      formControlName="platnostDo"
      dataType="dateAsString"
      fromKey="dateFrom"
      toKey="dateTo"
      data-cy="katalog-platnost-do" />
  </div>
</div>
